import React, { useEffect, useState } from "react";
import "../css/WorldStat.css";
import numeral from "numeral";

function WorldStat() {
  const [worldInfo, setWorldInfo] = useState([]);

  useEffect(() => {
    const getInfo = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries?sort=cases")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => ({
            country: country.country,
            cases: country.cases,
            active: country.active,
            recovered: country.recovered,
            deaths: country.deaths,
          }));
          setWorldInfo(countries);
        });
    };
    getInfo();
  }, []);

  return (
    <div className="worldStat">
      <h3>World Situation</h3>
      <table>
        <tbody>
          <tr>
            <th>Country</th>
            <th>Total Cases</th>
            <th>Active Cases</th>
            <th>Recovered</th>
            <th>Deaths</th>
          </tr>
          {worldInfo.map(({ country, cases, active, recovered, deaths }) => (
            <tr>
              <td>{country}</td>
              <td>{numeral(cases).format("0,0")}</td>
              <td>{numeral(active).format("0,0")}</td>
              <td>{numeral(recovered).format("0,0")}</td>
              <td>{numeral(deaths).format("0,0")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default WorldStat;
